import React, {useEffect, useState} from 'react';
import Styled from 'styled-components';
import connect from '../../../js_bytesize/config/purchase/connect';
import { device, breakpoints, getWidthRange } from '../../utils/responsive_utilities';
import { fontQuicksand} from '../../components/purchase/mixin';
import Reviews from '../../components/purchase/reviews/review-section';
import PlansSection from '../../components/purchase/plans';
import { melaDurationMap, computePricingInfo } from '../../../js_bytesize/templates/purchase/pricing-helper';
import MediaQuery from 'react-responsive';
import {
  UnsupportedLandscapeScreenShow,
} from '../../components/student/unsupported-landscape-screen';
import { isMobileDevice, redirectToStudentRoute } from '../../utils/web-helper';
import useCountdownTimer from '../../components/hooks/useCountdownTimer';
import { isPaymentElementEnabled, isFlutterSettingsAssigned } from '../../utils/feature_mapping';

function ProductList({ products, sendAnalytics, settings, skipSignUp, fromTrial, paymentSuccessHandlerForSVTrial, goToNextHandler, redirectUrl, ptlParent, parentDobYear}) {
  const subjectCodeMap ={
    Math: 'math',
    Maths: 'math',
    Reading: 'ela',
    'Math + Reading': 'mela',
    'Maths + Reading': 'mela'
  }
  const subjectFilterList = ['mela', 'math', 'ela']; // for maintaining the order of subjects in products
  const durationListForSorting = ['Yearly', 'Quarterly', 'Monthly'];
  const productsBySubject = new Map();
  const displayNames = {};
  const durationList = new Set();
  let {currency_code= 'USD'} =  products.length && products[0];
  let stripePaymentElementEnabled = isPaymentElementEnabled(settings)
  
  const sortYearlyProducts = productsBySubject => {
    productsBySubject.forEach((subjectValue) => {
      let yearlyProductsArray = [ ...subjectValue.get("Yearly")];
      if(yearlyProductsArray.length == 2){
        yearlyProductsArray.sort((a,b) => (a.credit_count || a.credit_products[0].credits_count) - (b.credit_count || b.credit_products[0].credits_count))
        subjectValue.set("Yearly", yearlyProductsArray);
      }
    })
  }
  products.forEach(element => {
    productsBySubject.set(subjectCodeMap[element.properties.display_name], new Map());
    displayNames[subjectCodeMap[element.properties.display_name]] = element.properties.display_name;
    durationList.add(melaDurationMap[element.access_duration]);
  })

  products.forEach((element) => {
    productsBySubject.get(subjectCodeMap[element.properties.display_name]).set(melaDurationMap[element.access_duration], []);
  })

  products.forEach((element) => {
    productsBySubject.get(subjectCodeMap[element.properties.display_name]).get(melaDurationMap[element.access_duration]).push(element);
  })

  sortYearlyProducts(productsBySubject);

  const filterTabMap = [];
  subjectFilterList.forEach((val)=>{
    if(Object.keys(displayNames).indexOf(val) > -1) {
      filterTabMap.push({
        id: val,
        title: displayNames[val]
      })
    }
  })

  const sortedDurationList = durationListForSorting.filter(val=>durationList.has(val));

  const [activeFilterTab, setActiveFilterTab] = useState(filterTabMap[0]);
  const timeLeft = useCountdownTimer({milliseconds: 0})

  const filterTabHandler = (val) => {
    trackAnalyticsEvent('Interacted All Plans Page', {'Interaction Details': `Changed Subject to ${val.title}`})
    setActiveFilterTab(val)
  }
  const [preferredPlanSaving, setPreferredPlanSaving] = useState(null);

  useEffect(()=>{
    typeof sendAnalytics!='undefined' && sendAnalytics('Viewed Purchase Page', window.purchasePageEventData);
    if(!settings.show_combined_landing_page_for_plan_page)
      typeof trackAnalyticsEvent!='undefined' && trackAnalyticsEvent("Visited Plan Purchase Combined Page", {
        'Stripe Payment Element Rendered': stripePaymentElementEnabled
          ? 'New Payment Element'
          : 'Old Credit Card Element'
      });
    if(products.length && sortedDurationList.length > 1) {
      let planProduct = productsBySubject.get(filterTabMap[0].id);
      let yearlyPriceInfo = computePricingInfo(planProduct.get(sortedDurationList[0])[0], settings);
      let quarterlyPriceInfo = computePricingInfo(planProduct.get(sortedDurationList[1])[0], settings);
      let planSaving = Math.floor(Math.abs(((yearlyPriceInfo.actualMonthlyPrice / quarterlyPriceInfo.actualMonthlyPrice) - 1) * 100));
      setPreferredPlanSaving(planSaving);
    }
  }, []);
  
  let crossHandler =  () => {
    let eventName = 'Interacted Pricing Screen';
    let eventObj = {
      'Clicked on': 'Cross',
      'Variation': 'Mela 1.0'
    }
    if (goToNextHandler) {
      trackAnalyticsEvent('Interacted on Plan Page', { 'Clicked On': 'Cross' });
      return goToNextHandler('purchase_page', { onCross: true });
    } else {
      sendAnalytics(eventName, eventObj);

      if (isFlutterSettingsAssigned()) {
        redirectToStudentRoute('/', true);
      } else {
        if (window.location.hash) return (redirectToStudentRoute('/'));
        else return (redirectToStudentRoute('/', true));
      }
    }
  }
  return (
    <>
      {isMobileDevice() && <MediaQuery query="only screen and (orientation: landscape)" >
        <UnsupportedLandscapeScreenShow />
      </MediaQuery>}

      <PurchaseBody className='purchase-body'>
        <Reviews settings={settings} />
        <PlanWrapper id="scroll-elt-parent" className='plans-wrapper'>
          {!!products.length ? <PlansSection 
            products={productsBySubject.get(activeFilterTab.id)}
            activeFilterTab={activeFilterTab}
            filterTabList={filterTabMap}
            filterTabHandler={filterTabHandler}
            productsBySubject={productsBySubject}
            sendAnalytics={sendAnalytics}
            sortedDurationList={sortedDurationList}
            preferredPlanSaving={preferredPlanSaving}
            skipSignUp = {skipSignUp}
            fromTrial = {fromTrial}
            paymentSuccessHandlerForSVTrial={paymentSuccessHandlerForSVTrial}
            redirectUrl = {redirectUrl}
            parentDobYear={parentDobYear}
            ptlParent={ptlParent}
            showDiscountChanges={false} /// make it false to remove urgency based discount feature
            timeLeft={timeLeft}
          /> : <h1>Some Error!</h1>}
          <CurrencyInfo>*All prices in {currency_code}</CurrencyInfo>
          <CrossBtn>
            <i className="iconcust-iconCrossBtn purchase-cross" onClick={() => crossHandler()}></i>
          </CrossBtn>
        </PlanWrapper>
      </PurchaseBody>
    </>
  )
}

function mapStateToProps(state) {
  return {
    products: state.products,
    settings: state.settings
  }
}

function mapDispatchToProps(dispatch) {
  return {
    refreshSetting: (data) => dispatch({type: "INITIALIZE", payload: data})
  }
}

export default connect(mapStateToProps, mapDispatchToProps, ProductList);

export const PurchaseBody = Styled.div`
  display: flex;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;

  @media (max-width: ${breakpoints.lg}px) {
    display: block;
    background-color: #141953;
  }
`;

export const PlanWrapper = Styled.div`
  position: relative;
  background-color: #141953;
  color: #fff;
  text-align: center;
  width: calc(100% - 36.8rem);
  overflow-y: auto;
  @media ${device.Phone}, ${device.PhoneLandscape}, ${device.PhoneLargeScreen}, ${device.Tablet}, ${device.TabletLandscape} {
    width: 100%;
    height: 100vh;
  }
`;

export const CurrencyInfo = Styled.p`
  text-align: left;
  margin: 0 0 0 1rem;
  position: fixed;
  bottom: 0.5rem;
  ${fontQuicksand(1.2, 1.6, 5)};
  @media ${device.Phone} {
    position: unset;
    margin-bottom: 1rem;
    margin-top: 1rem;
    text-align: center;
    display: none;
  }
  @media ${getWidthRange(767, 1025)} and (orientation: portrait) {
    position: unset;
    text-align: center;
  }
`;

export const CrossBtn = Styled.span`
  position: fixed;
  right: 2rem;
  top: 3rem;
  color: #4F52C3;
  width: 2.8rem;
  height: 3rem;
  cursor: pointer;

  @media ${device.Phone}{
    right: 1rem;
    top: 1rem;
  }
`
// Move code from js_bytesize to js
// The new plan page should be independent of the old one [web & mobile]
// Upgrade we will use existing code